type BannerProps = {
  img?: string;
  title?: string;
  subtitle?: string;
  visible?: boolean;
  bgColor?: string;
  mobileHeight?: string;
  mobileWidth?: string;
};
const BannerComponent = ({
  img,
  title,
  subtitle,
  visible,
  bgColor,
  mobileHeight,
  mobileWidth
}: BannerProps) => {
  return (
    <div className="offline-products-header-container">
      <img src={img} />
      <div className="offline-products-header">
        <h1>{title}</h1>
        <p dangerouslySetInnerHTML={{ __html: subtitle }} />
      </div>
      <style jsx>{`
        .offline-products-header-container {
          display: flex;
          justify-content: center;
          background-color: ${bgColor ? bgColor : "var(--color-red)"};
        }
        .offline-products-header-container img {
          width: 100%;
          height: 100%;
        }
        .offline-products-header {
          position: absolute;
          color: var(--color-white);
          max-width: 940px;
          width: 100%;
        }
        .offline-products-header h1 {
          font-weight: bold;
          margin: 5% 0 16px 16px;
        }
        .offline-products-header p {
          margin: 0 0 0 16px;
          font-size: 16px;
          width: 350px;
        }
        @media only screen and (max-width: 700px) {
          .offline-products-header-container {
            height: ${mobileHeight ? mobileHeight : "120px"};
            overflow: hidden;
          }
          .offline-products-header-container img {
            visibility: ${visible ? "" : "hidden"};
            width: ${mobileWidth ? mobileWidth : "100%"};
          }
          .offline-products-header h1 {
            font-weight: bold;
            margin: 16px 16px 8px 16px;
            font-size: 16px;
          }
          .offline-products-header p {
            font-size: 12px;
            width: auto;
          }
        }
      `}</style>
    </div>
  );
};
export default BannerComponent;
